import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@xo-union/tk-component-icons";
import noop from "lodash/noop";
import Overlay from "@xo-union/tk-component-overlay";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import { ModalContainer, ModalPortal } from "@xo-union/ui-accessibility";
import cx from "classnames";
import styles from "../../css/modal.css";
const Modal = _ref => {
  let {
    children,
    classes: classesProp,
    className,
    initialFocusRef,
    onClose,
    onCloseButtonClick,
    onEscapeKey,
    onOverlayClick,
    size,
    ...props
  } = _ref;
  const classes = useClasses(styles, classesProp);
  const handleXClick = evt => {
    onCloseButtonClick(evt);
    onClose(evt);
  };
  const classMap = {
    sm: classes.small,
    md: classes.medium,
    lg: classes.large
  };
  const sizeClass = classMap[size];
  return /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement(Overlay, {
    color: "dark",
    className: classes['modal-overlay']
  }, /*#__PURE__*/React.createElement(ModalContainer, _extends({
    className: cx(sizeClass, className),
    initialFocusRef: initialFocusRef,
    onClickOutside: onOverlayClick,
    onClose: onClose,
    onEscapeKey: onEscapeKey,
    focusLockProps: {
      className: classes['inner-modal-container']
    }
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classes['button-container']
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    block: true,
    className: classes['close-button'],
    name: "close",
    onClick: handleXClick,
    size: "md"
  })), children)));
};
Modal.defaultProps = {
  children: null,
  className: '',
  initialFocusRef: null,
  onClose: noop,
  onCloseButtonClick: noop,
  onEscapeKey: noop,
  onOverlayClick: noop,
  size: 'md'
};
process.env.NODE_ENV !== "production" ? Modal.propTypes = {
  /**
   * Contents of the modal
   */
  children: PropTypes.node,
  /**
   * Classes dependencies
   */
  classes: classesPropType(['small', 'medium', 'large', 'button-container', 'close-button', 'no-scroll']),
  /**
   * Additional styles to apply to the modal container
   */
  className: PropTypes.string,
  /**
   * Element to set as the initial focus
   */
  initialFocusRef: PropTypes.shape({
    current: PropTypes.shape({})
  }),
  /**
   * Called when overlay or X are clicked
   */
  onClose: PropTypes.func,
  /**
   * Called when X is clicked
   */
  onCloseButtonClick: PropTypes.func,
  /**
   * Called when ESC key is pressed
   */
  onEscapeKey: PropTypes.func,
  /**
   * Called when overlay is clicked
   */
  onOverlayClick: PropTypes.func,
  /**
   * Size class
   * */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
} : void 0;
export default Modal;